if (!customElements.get("m-collection-list")) {
  class MCollectionList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        slideControls: ".m-slider-controls",
        slideContainer: ".m-mixed-layout__wrapper",
        slideInner: ".m-mixed-layout__inner",
      };
      this.classes = {
        grid: 'm:grid',
        hidden: 'm:hidden',
        swiper: 'swiper-container',
        swiperWrapper: 'swiper-wrapper'
      };
      this.domNodes = queryDomNodes(this.selectors, this);

      this.slider = false;

      this.enableSlider = this.dataset.enableSlider === "true";
      this.items = this.dataset.items;
      this.total = this.dataset.total;
      this.autoplay = this.dataset.autoplay === "true";
      this.autoplaySpeed = this.dataset.autoplaySpeed;
      this.paginationType = this.dataset.paginationType;
      this.expanded = this.dataset.expanded === "true";
      this.mobileDisableSlider = this.dataset.mobileDisableSlider === "true";

      this.init();
      document.addEventListener("matchMobile", () => {
        this.init();
      });
      document.addEventListener("unmatchMobile", () => {
        this.init();
      });
    }

    init() {
      if (!this.enableSlider) return;
      if (MinimogTheme.config.mqlMobile && this.mobileDisableSlider) {
        this.destroySlider();
      } else {
        this.initSlider();
      }
    }

    initSlider() {
      const { slideContainer, slideControls, slideInner } = queryDomNodes(this.selectors, this);

      const prevButton = this.querySelector(".m-slider-controls__button-prev");
      const nextButton = this.querySelector(".m-slider-controls__button-next");
      const paginationIcon = `<svg width="65px" height="65px" viewBox="0 0 72 72" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><circle class="time" stroke-width="5" fill="none" stroke-linecap="round" cx="33" cy="33" r="28"></circle></svg>`;

      this.options = {
        slidesPerView: 2,
        loop: this.paginationType === "progressbar" ? false : true,
        slidesPerGroup: 1,
        showNavigation: true,
        showPagination: true,
        parallax: true,
        autoplay: this.autoplay
          ? {
            delay: parseInt(this.autoplaySpeed) * 1000,
          }
          : false,
        pagination:
          this.paginationType == "progressbar"
            ? false
            : this.paginationType == "fraction"
            ? {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
              type: "fraction",
            }
            : {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
              bulletClass: "m-dot",
              bulletActiveClass: "m-dot--active",
              renderBullet: function (index, className) {
                return '<span class="' + className + '">' + paginationIcon + "</span>";
              },
            },
        navigation: nextButton || prevButton ? {
          nextEl: nextButton && nextButton,
          prevEl: prevButton && prevButton
        } : false,
        autoHeight: true,
        breakpoints: {
          480: {
            slidesPerView: 3,
          },
          768: {
            slidesPerView: parseInt(this.items) >= 3 ? 3 : parseInt(this.items),
          },
          1280: {
            slidesPerView: this.expanded && this.total > this.items ? parseInt(this.items) + 1 : parseInt(this.items),
          },
        }
      };

      if (typeof this.slider !== 'object') {
        slideContainer.classList.add(this.classes.swiper);
        slideInner.classList.remove(this.classes.grid);
        slideInner.classList.add(this.classes.swiperWrapper);
        slideControls && slideControls.classList.remove(this.classes.hidden);
        this.slider = new MinimogLibs.Swiper(slideContainer, this.options);

        const updateProgressBar = () => {
          const progressFills = this.querySelectorAll(".m-slider-progress-fill");
          if (!progressFills.length || !this.slider) return;

          const snapCount = this.slider.snapGrid ? this.slider.snapGrid.length : 0;
          const totalSlides = this.slider.slides ? this.slider.slides.length : parseInt(this.total) || 1;
          const slidesPerView = (this.slider.params && typeof this.slider.params.slidesPerView === "number")
            ? this.slider.params.slidesPerView
            : 1;
          const totalSteps = snapCount > 0 ? snapCount : Math.max(1, totalSlides - slidesPerView + 1);

          if (totalSteps <= 1) {
            progressFills.forEach((fill) => {
              fill.style.width = "100%";
            });
            return;
          }

          const minPercent = (1 / totalSteps) * 100;
          let percentage = minPercent;

          if (this.slider.isEnd) {
            percentage = 100;
          } else if (this.slider.isBeginning) {
            percentage = minPercent;
          } else if (typeof this.slider.progress === "number" && !isNaN(this.slider.progress)) {
            percentage = minPercent + Math.max(0, Math.min(1, this.slider.progress)) * (100 - minPercent);
          } else {
            const currentStep = (this.slider.snapIndex !== undefined ? this.slider.snapIndex : this.slider.activeIndex || 0) + 1;
            percentage = (currentStep / totalSteps) * 100;
          }

          percentage = Math.min(100, Math.max(minPercent, percentage));
          progressFills.forEach((fill) => {
            fill.style.width = `${percentage}%`;
          });
        };

        if (this.paginationType === "progressbar" || this.querySelector(".m-slider-progress-fill")) {
          this.slider.on("slideChange", updateProgressBar);
          this.slider.on("setTranslate", updateProgressBar);
          this.slider.on("transitionEnd", updateProgressBar);
          this.slider.on("init", updateProgressBar);
          updateProgressBar();
        }
      }
    }

    destroySlider() {
      const { slideContainer, slideControls, slideInner } = queryDomNodes(this.selectors, this);

      slideContainer.classList.remove(this.classes.swiper);
      slideInner.classList.remove(this.classes.swiperWrapper);
      slideInner.classList.add(this.classes.grid);
      slideControls && slideControls.classList.add(this.classes.hidden);

      if (typeof this.slider === 'object') {
        this.slider.destroy();
        this.slider = false;
      }
    }
  }

  customElements.define("m-collection-list", MCollectionList);
}
